import React from "react";

import "./Job.css";
import { Link } from 'react-router-dom'
import Autocompete from './Autocompete'
import JobHeader from './JobHeader'
import {
  Typography,
  TextField,
  InputAdornment,
  Box,
  Button,
  // Autocomplete,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  MenuItem,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
} from "@material-ui/core";
import { useHistory } from 'react-router-dom'
import { makeStyles, useTheme } from '@material-ui/core/styles'
// import  { LinearProgressProps } from '@mui/material/LinearProgress';


// function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
//   return (
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <Box sx={{ width: '100%', mr: 1 }}>
//         <LinearProgress variant="determinate" {...props} />
//       </Box>
//       <Box sx={{ minWidth: 35 }}>
//         <Typography variant="body2" color="text.secondary">{`${Math.round(
//           props.value,
//         )}%`}</Typography>
//       </Box>
//     </Box>
//   );
// }
const useStyles = makeStyles((theme) => ({
  container: {
      marginLeft: "30px"
  },
  textField: {
      border: "1px solid #A9A9A9",
      borderRadius: "5px",
      padding: "10px",
  },
  label: {
      fontSize: "15px !important"
  }
}));

  // const [progress, setProgress] = React.useState(10);

  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
  //   }, 800);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);
  

const Job = () => {
    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()
    const [value, setValue] = React.useState('');

    const handleChange = (event) => {
        setValue(event.target.value);
    };
  return (
    
    <div class="job">
     <JobHeader/>
     <div className="job-container">
     <div className='job-title'>Copy Details from Existing Requisition</div>
     <div className="job-ans"><Autocompete/></div></div>
     <div className="job-container">
     <div className='job-title'>Supervisory Organization <span className="mandatory">*</span></div>
     <div className="job-ans"> <Autocompete/></div>
     </div>
    
<FormControl component="fieldset" style={{marginLeft: "35px"}}>
                    <RadioGroup aria-label="Position" name="gender1" value={value} onChange={handleChange}>
                        <FormControlLabel 
                            value="Create New Postion" 
                            control={<Radio color="primary" />} 
                            label={<Typography style={{fontSize: "15px"}}>Create New Postion</Typography>}
                        />
                        </RadioGroup></FormControl>

                      <div className="job-container">
     <div className='job-title'> 
     <FormControl component="fieldset" style={{marginLeft: "15px"}}>
                    <RadioGroup aria-label="Position" name="gender1" value={value} onChange={handleChange}>
      <FormControlLabel 
                            value="For Existing Postion" 
                            control={<Radio color="primary" />} 
                            label={<Typography style={{fontSize: "15px"}}>For Existing Postion</Typography>}
                        />
                    </RadioGroup></FormControl>
                </div> 
                <div className="job-ans"> 
       <Autocompete/> </div></div>
        <div className="job-container"> 
        <div className='job-title'>Worker type <span className="mandatory">*</span>  
        </div>
        <div className="job-ans"><div className="worker-type">
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Select one</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          
        >
          <MenuItem value={10}>Select one</MenuItem>
          <MenuItem value={20}>Contigent Worker </MenuItem>
          <MenuItem value={30}>Employee</MenuItem>
         
        </Select>
      </FormControl></div></div>
      </div>
     


                        <div className='next-bar'>
                        <Link to="#">  <button className='back-btn'>Cancel</button></Link>
                        <Link to="/Jobprocess"> <button className='next-btn'>Ok</button></Link>
          
        </div>
   

      
      
    
     
    {/* <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel value={progress} />
    </Box> */}
 
    </div> 
   
  );
}
export default Job;
